import React, { useState } from 'react'

import { Tooltip } from 'react-tooltip'

import CopyIcon from '@src/components/icons/Copy'
import { walletLogger } from '@src/utils/logger'

type CopyToClipboardProps = {
    textToCopy: string
    anchorId: string
    textType?: 'Address' | 'Referral Code'
}

const CopyToClipboard: React.FC<CopyToClipboardProps> = ({ textToCopy, anchorId, textType = 'Address' }) => {
    const [tooltipText, setTooltipText] = useState(`Copy ${textType}`)

    const handleCopy = () => {
        // Check if navigator.clipboard is available
        if (window.navigator.clipboard) {
            window.navigator.clipboard
                .writeText(textToCopy)
                .then(() => {
                    showCopiedMessage()
                })
                .catch(() => {
                    walletLogger.error('Browser does not support clipboard')
                })
        }
    }

    const showCopiedMessage = () => {
        setTooltipText(`${textType} Copied!`)
        setTimeout(() => {
            setTooltipText(`Copy ${textType}`)
        }, 2000) // Reset after 2 seconds
    }

    return (
        <div className='relative inline-block'>
            <span id={anchorId} data-tooltip-content={tooltipText} data-tooltip-place='left'>
                <CopyIcon onClick={handleCopy} className='cursor-pointer' />
            </span>
            <Tooltip anchorId={anchorId} />
        </div>
    )
}

export default CopyToClipboard
